'use strict'

$id = $('body').attr('id')
$class = $('body').attr('class')

# スムーススクロール関数モーション定義
jQuery.extend(
  jQuery.easing,{
    easeInOutCirc:
      (x, t, b, c, d) ->
        if (t/=d/2) < 1
          return -c/2 * (Math.sqrt(1 - t*t) - 1) + b
        c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b
  }
)

smoothScroll = (target, duration)->
  if duration is null
    duration = 1000

  if window.matchMedia('(max-width:750px)').matches
    scrollTo = $(target).offset().top - $('.l-header__logo').height() * 3
  else
    scrollTo = $(target).offset().top - $('.l-header__logo').height() * 3

  $(
    if (navigator.userAgent.indexOf('Opera') isnt -1)
    then (
      if document.compatMode is 'BackCompat'
      then 'body'
      else 'html'
    )
    else 'html,body'
  ).animate({
    scrollTop: scrollTo
  },{
    easing:'easeInOutCirc',
    duration: duration
  })

changeColor = () ->
  if window.matchMedia('(max-width:750px)').matches
    logoTiming =  24 + 19
    sideTiming =  window.innerHeight / 2 - 50
  else
    logoTiming =  33 + 44
    sideTiming =  window.innerHeight / 2 - 50

  trigger1 = document.getElementById('change-logo-2')
  trigger2 = document.getElementById('change-logo-3')

  trigger1Y = trigger1.getBoundingClientRect().top
  trigger2Y = trigger2.getBoundingClientRect().top

  # ロゴの色を変更
  if( trigger2Y - logoTiming > 0 and 0 >= trigger1Y - logoTiming )
    $('body').addClass('bg-is-black')
  else
    $('body').removeClass('bg-is-black')

  # # サイドリンクの色を変更
  # if( trigger2Y - sideTiming > 0 and 0 >= trigger1Y - sideTiming )
  #   $('.l-header__link').removeClass('is-black')
  # else
  #   $('.l-header__link').addClass('is-black')

resizeFlg = {}
resizeFlg.pc = true
resizeFlg.sp = true
firstView = ''
scroll = 0

$(window).on('scroll',
  ()->
    pageHeight = $(document).innerHeight()
    windowHeight = $(window).innerHeight()
    CopyrightHeight = $('.l-footer__copyright').innerHeight()
    passCopyright = pageHeight - windowHeight - CopyrightHeight * 3

    if not $('body').hasClass('index')
      changeColor()

    # PC/SP別処理
    if window.matchMedia('(max-width:750px)').matches
      # フッターCopyrightを通り過ぎたらサイドリンクの非表示
      if passCopyright <= $(window).scrollTop()
        $('.l-header__link').addClass('is-hide')
      else
        $('.l-header__link').removeClass('is-hide')

    else
      if $(window).scrollTop() >= 150
        $('.p-gnavi__logo').addClass('is-active')
      else
        $('.p-gnavi__logo').removeClass('is-active')

    if $(window).scrollTop() >= 200
      $('.pagetop').addClass('is-active')
    else
      $('.pagetop').removeClass('is-active')
)

$(window).on('load',
  ()->
    # keyName = 'visited'
    # keyValue = true
    #
    # if not sessionStorage.getItem(keyName)
    #   sessionStorage.setItem(keyName, keyValue)
    #   $('.loading').addClass('is-firstvisit')
    #
    #   dispnone = ->
    #     $('.loading').removeClass('is-firstvisit')
    #     $('body').addClass('is-disp')
    #     return
    #
    #   setTimeout(dispnone, 2000)
    # else
    #   $('body').addClass('is-disp')
    #
    # hash = location.hash
    #
    # if $(hash).length
    #   $('#gnavi').addClass('g-navi-relative')

    currentScrollPos = 0

    $('.js-ham-switcher').on('click',
      (e)->
        # e.stopPropagation()
        if $('body').hasClass('is-active-ham')
          $('body').removeClass('is-active-ham')
          $('html, body').scrollTop(currentScrollPos)
          $('.p-gnavi').removeClass('is-active')
          console.log(currentScrollPos)
        else
          currentScrollPos = $(window).scrollTop()
          # $('body').addClass('is-active-ham').css({
          #   top: currentScrollPos * -1
          # })
          $('body').addClass('is-active-ham')
          $('.p-gnavi').addClass('is-active')
          console.log(currentScrollPos)
    )

    if window.matchMedia('(max-width:750px)').matches
      firstView = 'SP'

      if $('body').hasClass('index')
        # $('.l-header').headroom({
        #   offset: $('.l-header__logo').offset().top
        # })
        # $('.l-fixed').headroom({
        #   offset: $('.l-header__logo').offset().top
        # })
        $('.l-header').headroom({
          offset: 200
        })
        $('.l-fixed').headroom({
          offset: 200
        })
      else
        $('.l-header').headroom({
          offset: 0
        })
        $('.l-fixed').headroom({
          offset: 0
        })

    else
      firstView = 'PC'

      $('.l-header').headroom({
        # offset: $('.l-header').outerHeight(true) - $('#gnavi').outerHeight(true)
        offset: 0
      })

      $('.l-fixed').headroom({
        offset: 0
      })

      if $('body').hasClass('index')
      else
        rellax = new Rellax('.js-rellax', {
          speed: -7,
          center: false,
          wrapper: null,
          round: true,
          vertical: true,
          horizontal: false
        })


    if location.href.indexOf('#') isnt -1
      $('a[href="#'+location.href.split('#')[1]+'"]').triggerHandler('click.smoothScroll')
)

$('a[href^="#"]').on('click.smoothScroll'
  (e)->
    e.preventDefault()

    smoothScroll($(this).attr('href'))
    # console.log( $(this).attr('href').length )
)

$(window).on('load',
  ()->
    if $('.p-about-us__introspection .p-about-us__introspection__image.is-display').length
      simpleSlideShow()
)

simpleSlideShow = ()->
  targetElement = $('.p-about-us__introspection .p-about-us__introspection__image')
  countImage = targetElement.length

  setInterval(
    ->
      # 現在表示されている画像の順番を取得
      displayImage = $('.p-about-us__introspection__image.is-display')
      currentNumber = displayImage.index()

      # 現在表示されている画像が最後でなければ、次の要素にclass付与
      if currentNumber isnt countImage - 1
        nextImage = displayImage.next()
        displayImage.removeClass('is-display')
        nextImage.addClass('is-display')
        # console.log( currentNumber )
      else
        nextImage = targetElement.eq(0)
        displayImage.removeClass('is-display')
        nextImage.addClass('is-display')
        # console.log( '終了' )

      return
    , 5000)
  return
